import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { SieniService } from "../../services/sieni.service";
import { MChapterData } from "../../models/chapter-data.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "chapter-item",
  templateUrl: "./chapter-item.component.html",
  styleUrls: ["./chapter-item.component.scss"],
})
export class ChapterItemComponent implements OnInit {
  constructor(
    private _globalService: SieniService,
    private translate: TranslateService
  ) {}

  @Input() public data: MChapterData = null;
  @Input() public moduleData: MChapterData;
  @Input() public title: string;
  @Input() public expanded: boolean = true;
  @Input() public load: boolean = false;
  @Input() public url: string = null;
  @Input() public type: string = null;

  public recent: boolean = false;
  public loading: boolean = false;
  public children: MChapterData[] = [];

  ngOnInit() {
    this.translate.setDefaultLang("es");
    this.translate.use(this._globalService.user.language.code);
    this.data.score =
      (this.data.score * this.getMaxScore(this.data.activeRequirements)) / 100;
    this.data.score.toFixed(2);

    setTimeout(() => {
      this.load = true;
    }, 50);
    // console.log(this.data)
    // console.log(this.generation)
    // console.log(this.generation % 2 === 0, "par")
  }

  public expand() {
    this.expanded = !this.expanded;
  }

  public getMaxScore(requirements: number): number {
    if (this.moduleData.activeRequirements > 0) {
      const maxScore =
        (requirements / this.moduleData.activeRequirements) * 100;
      return Math.round(maxScore);
    } else {
      return 0;
    }
  }

  public getScoreBarWidth(): string {
    if (this.getMaxScore(this.data.activeRequirements) > 0) {
      return (
        (this.data.score / this.getMaxScore(this.data.activeRequirements)) *
        100
      ).toString();
    } else {
      return "0";
    }
  }

  public getEvaluatedBarWidth(): string {
    if (this.data.activeRequirements > 0) {
      return (
        (this.data.evaluatedRequirements / this.data.activeRequirements) *
        100
      ).toString();
    } else {
      return "0";
    }
  }
}
